import { VehicleSearchDTO, VehicleSearchResults } from "./vehicleSearch.type";
import { processSearchResults } from "./processSearchResults";
import getEnvironment from "../getEnvironment";

const getSearchResults = async (
  url: string,
  authToken: string,
  isToUseAuthZero: boolean
): Promise<VehicleSearchResults> => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
    "Cache-Control": "private, max-age=0, no-cache, no-store",
  };

  if (getEnvironment() === "localhost") {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  const res = await fetch(url, {
    method: "GET",
    headers,
  });

  if (!res.ok) {
    throw new Error(
      `An error (${res.status}) occurred while fetching the data.`
    );
  }

  const result: VehicleSearchDTO = await res.json();
  return processSearchResults(result);
};

export default getSearchResults;
